import {
    Create,
    TextInput,
    required,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    minValue,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';

import HTMLEditorInput from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';

const BlogCreate = () => (
    <Create redirect={'/ce_blogs'}>
        <SimpleForm>
            <FileUpload
                type="VIDEO_THUMBNAIL"
                source={'thumbnail'}
                required={true}
                accept={'image/*'}
            />
            <ReferenceInput label="Blog Topic" source="blog_topic_id" reference="ce_blog_topics">
                <SelectInput optionText="name" fullWidth validate={[required()]} />
            </ReferenceInput>
            <TextInput source="title" fullWidth validate={[required()]} />
            <TextInput source="text_description" fullWidth validate={[required()]} />
            <SlugInput source="slug" fullWidth />
            <TextInput
                type={'number'}
                source="display_order"
                fullWidth
                validate={[required(), minValue(0)]}
            />
            <HTMLEditorInput source={'html_content'} fullWidth validate={[required()]} />
        </SimpleForm>
    </Create>
);

export default BlogCreate;
